import get from "lodash/get";
import React, { Component } from "react";
//id's in common.json
import { withTranslation } from "react-i18next";
import { Button, Form, Icon, Loader, Modal, Table } from "semantic-ui-react";

import { db, firebase } from "astrid-firebase";
import { toDate } from "astrid-web/src/helpers/fnc";

import CopyInput from "../../CopyInput";

class MasterModal extends Component {
	state = {};

	status = {
		queued: "Köad",
		start: "Påbörjad",
		download: "Källfiler",
		merge: "Sammanfogas",
		split: "Delas",
		convert: "Konverteras",
		zip: "Paketeras",
		upload: "Lagras",
		ftp: "Överförs",
		done: "Klar",
		expired: "Utgången",
		sent: "Skickad",
	};

	deleteExport = (id) => {
		const production = this.props.production;
		const storageRef = this.props.getStorage();

		// delete the file
		const zipPath = get(production, "master[this.props.article].exports[id].zip.path");
		const zip = zipPath && storageRef.child(zipPath);
		if (zip)
			zip.delete()
				.then(() => {
					console.log("export deleted");
				})
				.catch((err) => {
					console.log("export delete err", err);
				});

		// remove from db
		db.collection("productions")
			.doc(this.props.productionId)
			.set(
				{
					master: {
						[this.props.article]: {
							exports: {
								[id]: firebase.firestore.FieldValue.delete(),
							},
						},
					},
				},
				{ merge: true },
			);
	};

	closeExportModal = () => {
		this.setState({ modal: null });
	};

	exportUrl = (id) =>
		window.location.protocol +
		"//" +
		window.location.host +
		"/export/" +
		this.props.productionId +
		"/" +
		this.props.article +
		"/" +
		id;

	render() {
		const { t, article, production, modifiedSettings } = this.props;
		const { modal } = this.state;

		const duration = get(production, "master." + article + ".settings.duration");
		const approved = get(production, "master." + article + ".settings.approved");

		return (
			<>
				{duration && !modifiedSettings && approved !== false && (
					<div className="flex-stack" style={{ marginTop: "2em", minHeight: 300 }}>
						{production.master[article].exports &&
							!!Object.keys(production.master[article].exports).length && (
								<Table size="small" collapsing>
									<Table.Header>
										<Table.Row>
											<Table.HeaderCell>{t("splitMaster")}</Table.HeaderCell>
											<Table.HeaderCell>{t("formatMaster")}</Table.HeaderCell>
											<Table.HeaderCell>{t("statusMaster")}</Table.HeaderCell>
											<Table.HeaderCell>{t("exportMaster")}</Table.HeaderCell>
										</Table.Row>
									</Table.Header>
									<Table.Body>
										{Object.entries(production.master[article].exports)
											.sort((a, b) => (a[0] > b[0] ? 1 : -1))
											.map(([id, exp]) => {
												const expired =
													!exp.status ||
													toDate(exp.created) <
														toDate(production.master[article].settings.date);

												if (expired) exp.status = "expired";

												return (
													<Table.Row key={id}>
														<Table.Cell>
															{
																{
																	split: t("splits"),
																	chapter: t("chapter"),
																	total: t("total"),
																	parts: t("parts"),
																}[exp.part]
															}
														</Table.Cell>
														<Table.Cell>
															<span style={{ display: "inline-block", minWidth: 30 }}>
																{exp.format && exp.format.toUpperCase()}
															</span>
															{exp.format !== "wav" &&
																(exp.bitrate &&
																(exp.bitrate + "").substr(0, 4) === "auto"
																	? exp.bitrate === "auto700"
																		? "auto 700mb"
																		: "auto 650mb"
																	: exp.bitrate + "kbps")}
															{exp.mono && " mono"}
															{exp.iso && " ISO"}
															{exp.ddp && " DDP"}
														</Table.Cell>
														<Table.Cell>
															<Icon
																name="circle"
																color={
																	exp.status === "done"
																		? "green"
																		: expired
																		? "yellow"
																		: "orange"
																}
															/>
															{t("exportStatus" + exp.status)}
														</Table.Cell>
														<Table.Cell>
															{!expired &&
																(exp.status === "done" ? (
																	<Button
																		primary
																		size="mini"
																		as="a"
																		icon="download"
																		href={exp.zip.url}
																		content={t("downloadBtn")}
																	/>
																) : (
																	<span>
																		<Loader
																			active
																			inline
																			size="tiny"
																			style={{ verticalAlign: "text-bottom" }}
																		/>{" "}
																		<em>{t("processing")}</em>
																	</span>
																))}
															{!expired && exp.status === "done" && (
																<Button
																	color="teal"
																	icon="share"
																	size="mini"
																	content={t("share")}
																	onClick={(e) => {
																		this.setState({
																			modal: {
																				type: "share",
																				article,
																				export: id,
																			},
																		});
																	}}
																/>
															)}
															{["done", "expired", "error"].includes(exp.status) && (
																<Button
																	color="red"
																	icon="trash alternate"
																	size="mini"
																	content={t("delete")}
																	onClick={(e) => {
																		if (
																			window.confirm(
																				t("sureAboutDeleteExportAndFile"),
																			)
																		) {
																			this.deleteExport(id);
																		}
																	}}
																/>
															)}
														</Table.Cell>
													</Table.Row>
												);
											})}
									</Table.Body>
								</Table>
							)}
					</div>
				)}

				{modal && (
					<Modal size="small" open={true} onClose={this.closeExportModal} closeOnDocumentClick>
						<Modal.Header>{t("shareExport")}</Modal.Header>
						<Modal.Content>
							<Form>
								<Form.Input
									type="email"
									label={t("emailAddress")}
									value={this.state.exportEmail || ""}
									onChange={(e, data) => {
										this.setState({ exportEmail: data.value });
									}}
								/>
								<p>
									{t(
										"clickBtnToPrepareEmail",
										"Click button below to prepare an email for your e-mail client",
									)}
								</p>
								<p>{t("copyThisLink")}</p>

								<CopyInput content={this.exportUrl(modal.export)} />
							</Form>
						</Modal.Content>
						<Modal.Actions>
							<Button onClick={this.closeExportModal}>{t("close")}</Button>
							<Button
								positive
								icon="send"
								labelPosition="right"
								content={t("send")}
								disabled={!this.state.exportEmail}
								onClick={() => {
									const url = this.exportUrl(modal.export);

									window.location =
										"mailto:" +
										this.state.exportEmail +
										"?subject=" +
										production.title +
										"&body=" +
										encodeURIComponent(t("clickToDownloadProd")) +
										url;
								}}
							/>
						</Modal.Actions>
					</Modal>
				)}
			</>
		);
	}
}

export default withTranslation()(MasterModal);
